/* Copyright (c) 2020-2023 Nordcloud Oy or its affiliates. All Rights Reserved. */

import { ButtonHTMLAttributes } from "react";
import styled from "styled-components";
import { WithChildren } from "~/tools";

type StyledButtonProps = Pick<ButtonWrapProps, "display">;

const StyledButton = styled.button<StyledButtonProps>`
  display: ${({ display }) => display || "block"};
  border: 0;
  outline: none;
  margin: 0;
  padding: 0;
  width: auto;
  overflow: visible;
  background: transparent;
  color: inherit;
  font: inherit;
  line-height: normal;
  appearance: none;
`;

type ButtonWrapProps = ButtonHTMLAttributes<HTMLButtonElement> &
  WithChildren & {
    display?: string;
  };

export function ButtonWrap({ display, children, type = "button", ...props }: ButtonWrapProps) {
  return (
    <StyledButton display={display} type={type} {...props}>
      {children}
    </StyledButton>
  );
}
